// TO DO: remove once managed user and week one user are supported
import SignupModule from "@/components/signup/bxp-ui-signup/src";
import { useCohort } from "@/components/user-context";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { LoggedInJiraFreeExistingSitesUser } from "./existing-sites-user";
import { LoggedInJiraFreeManagedUser } from "./managed-user";
import { LoggedInJiraFreeNewUser } from "./new-user";

export const LoggedInJiraFree = () => {
    const cohort = useCohort();

    if (cohort === "new-user") {
        return <LoggedInJiraFreeNewUser />;
    }

    if (
        cohort === "managed-user" &&
        checkFeatureFlagGate(featureFlags.jfindSiteActivationManagedUser)
    ) {
        return <LoggedInJiraFreeManagedUser />;
    }

    // if (cohort === "week-one-user") {
    //     return <LoggedInJiraFreeWeekOneUser />;
    // }

    if (cohort === "existing-user") {
        return <LoggedInJiraFreeExistingSitesUser />;
    }

    if (cohort) {
        return <SignupModule bundle="jira-software" edition="free" />;
    }

    return null;
};
